module.exports = __webpack_public_path__ + "static/media/15.a1036f6e.jpg";